<template>
    <header id="st-header">
        <div class="head-wrap">
            <!-- 소개 페이지, 매장목록 상단 -->
            <div class="head-left" v-if="!isHome">
                <button type="button" class="btn-head-back" aria-label="뒤로가기" @click="doMoveBack()"></button>
                <router-link
                    :to="{
                        path: '/',
                        query: { ...$route.query },
                    }"
                    class="btn-head-home"
                    aria-label="홈으로 이동"
                ></router-link>
            </div>

            <div ref="dropdownRef" v-if="isHome" :class="['gnb-mall', { active: isExpanded }]" :aria-expanded="isExpanded">
                <h1 class="head-tit blind">스타필드 마켓</h1>
                <button
                    type="button"
                    aria-label="브랜드 사이트 바로가기"
                    aria-haspopup="menu"
                    :aria-expanded="isExpanded"
                    @click="toggleHeader"
                ></button>
                <ul class="layer-gate">
                    <li class="emart">
                        <a href="#" @click.prevent="goToUrl('/main/main.do')" aria-label="이마트"></a>
                    </li>
                    <li class="traders">
                        <a href="#" @click.prevent="goToUrl('/traders/main.do')" aria-label="트레이더스"></a>
                    </li>
                </ul>
            </div>

            <h1 v-else class="head-tit">
                <span>{{ pageTitle }}</span>
            </h1>

            <!-- 상단 Navi 버튼제어 -->
            <div class="head-right">
                <button type="button" class="btn-head-menu" @click="doOpenClose" aria-label="전체 메뉴 열기"></button>
            </div>

            <!-- 메뉴표시 -->
            <LayoutSlide @close="doMenuClose" :isSlide="isSlide" />
        </div>
    </header>
</template>

<script setup>
    import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import LayoutSlide from '@/components/layout/LayoutSlide.vue';

    const $route = useRoute();
    const $router = useRouter();

    const isSlide = ref(false);
    const isExpanded = ref(false);
    const dropdownRef = ref(null);

    const isHome = computed(() => $route.name === 'home');
    const pageTitle = computed(() => $route.meta.title || '스타필드 마켓');

    const doOpenClose = () => (isSlide.value = !isSlide.value);
    // 메뉴 열기/닫기
    const doMenuClose = () => (isSlide.value = false);
    // 이전페이지로 이동(Modal페이지 감추기 또는 이전페이지로 이동)
    const doMoveBack = () => {
        const isPopup = !!window.opener;

        if (isPopup && history.length <= 1) {
            window.close();
        } else {
            $router.back();
        }
    };
    const goToUrl = (url) => {
        const newUrl = process.env.VUE_APP_EMART_API + url;

        if ($route.query.isApp === 'true') {
            location.href = `emart-today://close_and_open_main_home/?link=${newUrl}`;
        } else {
            location.href = newUrl;
        }
    };
    const toggleHeader = () => {
        isExpanded.value = !isExpanded.value;
    };
    const handleClickOutside = (event) => {
        if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
            isExpanded.value = false;
        }
    };

    onMounted(() => {
        document.addEventListener('click', handleClickOutside);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutside);
    });
</script>
